import { faAddressBook, faChalkboardTeacher, faFolderOpen, faFileSignature, faFileContract, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import Forms_icon from "@assets/images/Forms_icon.png";
import Protocols_icon from "@assets/images/Protocols_icon.png";
import contacts_icon from "@assets/images/contacts_icon.png";
import ContEdu_icon from "@assets/images/ContEdu_icon.png";
import Credentials_icon from "@assets/images/Credentials_icon.png";
import Documents_icon from "@assets/images/Documents_icon.png";
import Selfservice_icon from "@assets/images/Selfservice_icon.png";
import Safety_icon from "@assets/images/Safety_icon.png";
//import notifications_logo from "@assets/images/notifications_logo.png"

export const connect_modules = [
  {
    "name": "Contacts",
    "logo": contacts_icon,
    "link": "/contacts",
    "isActive": true
  },
  {
    "name": "Continuing Education",
    "logo": ContEdu_icon,
    "link": "/continuing_education",
    "isActive": true
  },
  {
    "name": "Credentials",
    "logo": Credentials_icon,
    "link": "/credentials",
    "isActive": true
  },
  {
    "name": "Documents",
    "logo": Documents_icon,
    "link": "/documents",
    "isActive": true
  },
  {
    "name": "Forms",
    "logo": Forms_icon,
    "link": "/forms",
    "isActive": true
  },
  {
    "name": "Protocols",
    "logo": Protocols_icon,
    "link": "/protocols",
    "isActive": true
  },
  {
    "name": "Self Service",
    "logo": Selfservice_icon,
    "link": "/self_service",
    "isActive": true
  },
  {
    "name": "Safety",
    "logo": Safety_icon,
    "link": "/safety",
    "isActive": false
  },

  // {
  //   "name": "Notifications",
  //   "logo": notifications_logo,
  //   "link": "/notifications",
  //   "isActive": true
  // },
];